import { createContext as i } from "react";
import { jsx as o } from "theme-ui/jsx-runtime";
const n = i({
  genericLink: ({
    children: r,
    href: t,
    linkSx: e
  }) => /* @__PURE__ */ o("a", {
    href: t,
    sx: e,
    children: r
  }),
  cloudinarySettings: {
    baseUrl: "",
    s3Url: "",
    s3BlogUrl: ""
  }
}), a = ({
  children: r,
  genericLink: t,
  cloudinarySettings: e
}) => /* @__PURE__ */ o(n.Provider, {
  value: {
    genericLink: t,
    cloudinarySettings: e
  },
  children: r
});
export {
  n as UIKitContext,
  a as UIKitProvider
};
